import { Modal, Space } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled } from "@ant-design/icons"
import TableLayout from "../../components/layouts/TableLayout";
import { deleteData, getData } from "../../helpers/api";
import AddAccounts from "../../components/users/AddAccounts";
import { INITIAL_ACTIONS } from "../../constants/others";
import { openNotification } from "../../helpers/alerts";

const { confirm } = Modal;

const INITIAL_VALUE = {
    userId: null,
    deliveryCompaniesIds: null,
    deliveryCompanyKeysIds: null
}
const Accounts = () => {
    const [employer, setEmployer] = useState(INITIAL_VALUE)
    const [employers, setEmployers] = useState([])
    const [total, setTotal] = useState(0)

    const columns = useMemo(() => [
        {
            title: "Nom",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Sociétés",
            dataIndex: "deliveryCompanies",
            key: "deliveryCompanies",
        },
        {
            title: "Comptes",
            dataIndex: "deliveryCompanyKeys",
            key: "deliveryCompanyKeys",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => {
                return (
                    <Space size="middle">
                        <span>
                            <DeleteOutlined
                                onClick={() => {
                                    showDeleteConfirm(record.id)
                                 }}
                            />
                        </span>
                        <span>
                            <EditOutlined
                                onClick={() => {
                                    let employerToEdit = employers.find((el) => el.id === record.id);
                                    employerToEdit = {
                                        subordinatedName:employerToEdit.name,
                                        userId: employerToEdit.id,
                                        deliveryCompaniesIds: employerToEdit.deliveryCompanies.map((el) => el.id),
                                        deliveryCompanyKeysIds: employerToEdit.deliveryCompanyKeys.map((el) => el.id),
                                        edit: true
                                    }
                                    setEmployer(employerToEdit);
                                }}
                            />
                        </span>
                    </Space>
                )
            },
        }
    ], [employers])


    const showDeleteConfirm = (subordinatedId) => {
        confirm({
            title: 'Vous êtes sûr de supprimer ce produit ?',
            icon: <ExclamationCircleFilled />,
            okText: 'Suprimer',
            okType: 'danger',
            cancelText: 'Anuler',
            onOk() {
                removeAccount(subordinatedId)
            },
        });
    };


    const removeAccount = async (subordinatedId) => {
        try {
            await deleteData(`subordinated/accounts/${subordinatedId}`);
            openNotification(`Les comptes ont été suprimer avec succès`, 'success');
            getEmployersWithAccounts();
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }

    const getEmployersWithAccounts = useCallback(async (page = 1, limit = 10) => {
        try {
            const res = await getData('/subordinated/accounts', {
                page,
                limit,
            })
            setEmployers(res.data.employers)
            setTotal(res.data.total)
        } catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        getEmployersWithAccounts()
    }, [getEmployersWithAccounts])

    const mapUSerData = (mappedEmployers) => {
        return mappedEmployers.map((employer) => ({
            id: employer.id,
            name: `${employer.name}/${employer.role}`,
            deliveryCompanies: employer.deliveryCompanies.map((el) => el.name).join(";"),
            deliveryCompanyKeys: employer.deliveryCompanyKeys.map((el) => el.name).join(";")
        }))
    }

    const handleCancel = () => {
        setEmployer({ ...INITIAL_VALUE, INITIAL_ACTIONS })
    }

    const handleAfterAddingAccount = () => {
        getEmployersWithAccounts()
        handleCancel()
    }
    return (
        <>
            {(employer.add || employer.edit) && <AddAccounts
                initialValue={employer}
                isModalOpen={employer.add || employer.edit}
                handleCancel={handleCancel}
                handleAfterAddingAccounts={handleAfterAddingAccount}
            />}
            <TableLayout
                columns={columns}
                total={total}
                getData={getEmployersWithAccounts}
                dataSource={mapUSerData(employers)}
                setAddElementModal={() => { setEmployer({ ...INITIAL_VALUE, add: true }) }}
            />
        </>
    );
}

export default Accounts;